import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProviderStatementBalanceEmailTemplate.DeleteAttachment.IRequest;
type Response = Api.Core.ProviderStatementBalanceEmailTemplate.DeleteAttachment.IResponse;
type Headers = Api.Core.ProviderStatementBalanceEmailTemplate.DeleteAttachment.IHeaders;
const apiProviderStatementBalanceEmailTemplateDeleteAttachmentPath =
  '/api/Management/ProviderStatementBalanceEmailTemplate/:id/DeleteAttachment/:fileId';
export default async function providerStatementBalanceEmailTemplateDeleteAttachmentApi(
  id: number,
  request: Request
): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    body: request,
    url: createPathFromRoute(apiProviderStatementBalanceEmailTemplateDeleteAttachmentPath, {
      id,
      fileId: request.fileId,
    }),
    method: HttpMethod.delete,
    headers: getDefaultHeaders(),
  });
}
